module.exports = __webpack_public_path__ + "fonts/RundigsburgPlain.d83c582.woff2";